import 'css-chunksrc/client/pages/occupancyPage/table/row/cell/styles.scss';export default {
  "cell": "_cell_3d0vs_1",
  "value": "_value_3d0vs_14",
  "ok": "_ok_3d0vs_19",
  "warn": "_warn_3d0vs_23",
  "over": "_over_3d0vs_27",
  "none": "_none_3d0vs_31",
  "warningIcon": "_warningIcon_3d0vs_35"
};